import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { customerEditPassword } from "../../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import AccountWidget from "../../components/shared/AccountWidget";
import FlashMessage from "../../components/shared/FlashMessage";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";
import { Link } from "react-router-dom";
import styles from "../../thema/style";
import "../../styles/ModernPassword.css";

class EditPassword extends Component {
  state = {
    old_password: "",
    password: "",
    password_c: "",
    errors: [],
    showOldPassword: false,
    showNewPassword: false,
    showConfirmPassword: false
  };

  renderErrorMessage() {
    if (this.props.customer.errors.length > 0) {
      return (
        <div className="modern-password-error-alert">
          <h4 className="alert-heading">
            <FontAwesomeIcon icon="exclamation-triangle" />
            Hata Meydana Geldi!
          </h4>
          <ul>
            {this.props.customer.errors.map((error, i) => (
              <li key={i}>{error.message}</li>
            ))}
          </ul>
        </div>
      );
    }

    if (this.state.errors.length > 0) {
      return (
        <div className="modern-password-error-alert">
          <h4 className="alert-heading">
            <FontAwesomeIcon icon="exclamation-triangle" />
            Hata Meydana Geldi!
          </h4>
          <ul>
            {this.state.errors.map((error, i) => <li key={i}>{error}</li>)}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }

  validate = () => {
    const errors = [];
    if (!this.state.old_password)
      errors.push("Mevcut Şifreniz alanı boş bırakılamaz!");
    if (!this.state.password)
      errors.push("Yeni Şifreniz alanı boş bırakılamaz!");
    if (!this.state.password_c)
      errors.push("Yeni Şifreniz (Tekrar) alanı boş bırakılamaz!");
    if (this.state.password !== this.state.password_c)
      errors.push("Şifreniz ve Şifreniz (Tekrar) alanları aynı olmalıdır!");
    return errors;
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  togglePasswordVisibility = (field) => {
    this.setState(prevState => ({
      [field]: !prevState[field]
    }));
  };

  onSubmit = e => {
    e.preventDefault();
    var errors = this.validate();
    this.setState({ errors: errors });
    if (errors.length === 0) {
      this.props.customerEditPassword({ ...this.state });
      // this.props.updateProfile({ ...this.state });
    }
  };

  render() {
    if (this.props.customer.fetching) {
      return (
        <div className="modern-password-container">
          <div className="container">
            <div className="password-loading">
              <div className="password-loading-spinner"></div>
              <div className="password-loading-text">Sayfa Yükleniyor...</div>
            </div>
          </div>
        </div>
      );
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap"
              // state: { referrer: currentLocation }
            }}
          />
        );
      }
      return (
        <React.Fragment>
          <PageTitle title={"Şifremi Değiştir"} />
          <div className="modern-password-container">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"}>
                  {/* Modern Header */}
                  <div className="modern-password-header">
                    <div className="password-header-content">
                      <h1 className="password-title">
                        <FontAwesomeIcon icon="lock" />
                        Şifremi Güncelle
                      </h1>
                      <p className="password-subtitle">
                        Hesap güvenliğiniz için güçlü bir şifre seçin
                      </p>
                      <div className="password-breadcrumb">
                        <Link to="/hesabim">Hesabım</Link>
                        {" / "}
                        <span>Şifremi Güncelle</span>
                      </div>
                    </div>
                  </div>

                  {/* Security Tips */}
                  <div className="password-security-tips">
                    <div className="security-tips-header">
                      <FontAwesomeIcon icon="shield-alt" />
                      <span>Güvenli Şifre İpuçları</span>
                    </div>
                    <ul className="security-tips-list">
                      <li>
                        <FontAwesomeIcon icon="check-circle" className="tip-icon" />
                        En az 8 karakter uzunluğunda olmalı
                      </li>
                      <li>
                        <FontAwesomeIcon icon="check-circle" className="tip-icon" />
                        Büyük ve küçük harfler içermeli
                      </li>
                      <li>
                        <FontAwesomeIcon icon="check-circle" className="tip-icon" />
                        En az bir rakam ve özel karakter bulunmalı
                      </li>
                      <li>
                        <FontAwesomeIcon icon="check-circle" className="tip-icon" />
                        Kişisel bilgilerinizi içermemeli
                      </li>
                    </ul>
                  </div>

                  {/* Error Messages */}
                  {this.renderErrorMessage()}

                  {/* Success Message */}
                  {this.props.customer.success && (
                    <div className="modern-password-success-alert">
                      <div className="success-icon">
                        <FontAwesomeIcon icon="check-circle" />
                      </div>
                      <span>Şifreniz başarıyla güncellendi!</span>
                    </div>
                  )}

                  <FlashMessage />

                  {/* Password Form Card */}
                  <div className="modern-password-form-card">
                    <div className="password-form-header">
                      <div className="password-form-icon">
                        <FontAwesomeIcon icon="key" />
                      </div>
                      <div className="password-form-header-text">
                        <h3>Şifre Güncelleme</h3>
                        <p>Mevcut şifrenizi doğrulayın ve yeni şifrenizi belirleyin</p>
                      </div>
                    </div>

                    <form className="modern-password-form" onSubmit={this.onSubmit}>
                      <div className="password-form-group">
                        <label className="password-form-label">Mevcut Şifreniz</label>
                        <div className="password-input-with-icon">
                          <div className="password-input-icon">
                            <FontAwesomeIcon icon="lock" />
                          </div>
                          <input
                            type={this.state.showOldPassword ? "text" : "password"}
                            className="password-form-control"
                            name="old_password"
                            value={this.state.old_password}
                            placeholder="Mevcut şifrenizi giriniz"
                            onChange={e => {
                              this.handleChange(e);
                            }}
                            required
                          />
                          <div
                            className="password-toggle-icon"
                            onClick={() => this.togglePasswordVisibility('showOldPassword')}
                          >
                            <FontAwesomeIcon
                              icon={this.state.showOldPassword ? "eye-slash" : "eye"}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="password-form-group">
                        <label className="password-form-label">Yeni Şifreniz</label>
                        <div className="password-input-with-icon">
                          <div className="password-input-icon">
                            <FontAwesomeIcon icon="key" />
                          </div>
                          <input
                            type={this.state.showNewPassword ? "text" : "password"}
                            className="password-form-control"
                            name="password"
                            value={this.state.password}
                            placeholder="Yeni şifrenizi giriniz"
                            onChange={e => {
                              this.handleChange(e);
                            }}
                            required
                          />
                          <div
                            className="password-toggle-icon"
                            onClick={() => this.togglePasswordVisibility('showNewPassword')}
                          >
                            <FontAwesomeIcon
                              icon={this.state.showNewPassword ? "eye-slash" : "eye"}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="password-form-group">
                        <label className="password-form-label">Yeni Şifreniz (Tekrar)</label>
                        <div className="password-input-with-icon">
                          <div className="password-input-icon">
                            <FontAwesomeIcon icon="key" />
                          </div>
                          <input
                            type={this.state.showConfirmPassword ? "text" : "password"}
                            className="password-form-control"
                            name="password_c"
                            value={this.state.password_c}
                            placeholder="Yeni şifrenizi tekrar giriniz"
                            onChange={e => {
                              this.handleChange(e);
                            }}
                            required
                          />
                          <div
                            className="password-toggle-icon"
                            onClick={() => this.togglePasswordVisibility('showConfirmPassword')}
                          >
                            <FontAwesomeIcon
                              icon={this.state.showConfirmPassword ? "eye-slash" : "eye"}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="password-form-actions">
                        <button
                          type="button"
                          className="password-action-btn password-cancel-btn"
                          onClick={e => {
                            e.preventDefault();
                            this.props.history.push("/hesabim");
                          }}
                        >
                          <FontAwesomeIcon icon="times" />
                          İptal Et
                        </button>
                        <button
                          type="submit"
                          className="password-action-btn password-save-btn"
                          disabled={this.props.customer.updating}
                        >
                          {this.props.customer.updating ? (
                            <React.Fragment>
                              <FontAwesomeIcon icon="spinner" spin />
                              Güncelleniyor...
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <FontAwesomeIcon icon="save" />
                              Şifremi Güncelle
                            </React.Fragment>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { customerEditPassword };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPassword);



// WEBPACK FOOTER //
// ./src/routers/Account/edit_password.js